import {Injectable} from '@angular/core';
import { getLocalData} from '@gebeya/g-saas-core-mf-shared-ts';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HTTP_INTERCEPTORS
} from '@angular/common/http';

import {Observable} from 'rxjs';
import { ConfigModel } from 'src/app/shared/models/config.model';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  tenantId = '';
  config?: ConfigModel;
  constructor() {
    this.getConfiguration();
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addTenantId(request));
  }

  addTenantId(request: HttpRequest<any>) {
    if(this.config?.tenantId) {
      return request.clone({
        setHeaders: {
          'x-tenant-id': this.config.tenantId
        }
      })
    }
    return request
  }


  getConfiguration() {
    this.config = getLocalData('market_place_config');
  }
}

export const httpAuthInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
